import PropTypes from 'prop-types';
import includes from "ramda/es/includes";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCduUser } from '@gef-ui/cdu-user/selectors';
import { Tabs } from '@gef-ui/components/organisms/Tabs';
import GcpLogo from '../../../../components/assets/images/GCP-2X.svg';
import { COMPANY_STR } from '../../constants';
import { getDelegations } from '../../selectors';
import DelegationTab from '../DelegationTab';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'Delegations';
const Delegations = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { continueAction, userInfoEndpointCreators, selectors, Wrapper } = props;
    const { allowedCompanies = [], userFullName } = useSelector(getCduUser);
    const [userLogin] = useState(userFullName);
    const [allowedCp] = useState(includes(COMPANY_STR.CP, allowedCompanies));
    const delegations = useSelector(getDelegations);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Delegations"
    }, /*#__PURE__*/ React.createElement(Tabs, {
        useHorizontalScroll: true
    }, /*#__PURE__*/ React.createElement(DelegationTab, {
        allowedCompany: allowedCp,
        userFullName: userLogin,
        delegations: delegations,
        label: /*#__PURE__*/ React.createElement("img", {
            alt: "logo",
            src: GcpLogo
        }),
        continueAction: continueAction,
        userInfoEndpointCreators: userInfoEndpointCreators,
        selectors: selectors,
        Wrapper: Wrapper,
        visible: true
    })));
};
Delegations.propTypes = {
    Wrapper: PropTypes.any,
    continueAction: PropTypes.func,
    selectors: PropTypes.shape({
        getIsLogoutFetchLoaded: PropTypes.func,
        getIsOriginalUserFetchLoaded: PropTypes.func
    }),
    userInfoEndpointCreators: PropTypes.shape({
        createFetchAction: PropTypes.func,
        createFetchActionWithRepresentedUser: PropTypes.func
    })
};
export default Delegations;
